import { loadAndAwait } from 'google-fonts-loader';
import { writable } from 'svelte/store';
import { loadGoogleFontFromSS } from '../../types/metadata';
import { SiteCache } from '../../cache/Cache';
export const loadGoogleFont = async (fontFamily) => {
    // console.log('loading a google font', fontFamily);
    // return loadGoogleFontFromSS(fontFamily as string);
    try {
        return await loadGoogleFontFromSS(fontFamily);
    }
    catch (e) {
        return fallbackLoadGoogleFontFromPublicRepository(fontFamily);
    }
};
/**
 *
 * @param fontFamily The font family to load
 * @returns Promise<FontFace> The loaded font
 *
 * @fallbackonly
 *
 * This function is a fallback function only and not to be used for anything
 */
async function fallbackLoadGoogleFontFromPublicRepository(fontFamily) {
    try {
        //   if (!fontFamily) fontFamily = this.metadata.fontFamily.value;
        const loadedFont = await loadAndAwait({
            [fontFamily]: ['400', '500', '600', '700', '800', '900']
        });
        return loadedFont;
    }
    catch (err) {
        console.warn('Could not load google font', err);
        return null;
    }
}
export function getFontNameWithoutExtension(fileName) {
    const replacedFileName = fileName.replace(/[^\w\s]/gi, '_').replace(/\s+/g, '_');
    return replacedFileName.split('.').slice(0, -1).join('.');
}
export const loadUserFont = async (fontName, fontUrl) => {
    // Check that fontUrl ends with a font extension
    if (!fontUrl.match(/\.(woff|woff2|ttf|otf)$/)) {
        console.warn('Invalid font url', fontUrl);
        return null;
    }
    return new Promise((resolve, reject) => {
        let userFont = new FontFace(fontName, `url(${fontUrl})`);
        try {
            const siteFont = SiteCache.customUserFonts.find(font => font.label == fontName);
            if (!siteFont) {
                console.log('[SiteCache] Adding font to SiteCache', fontName, fontUrl);
                SiteCache.customUserFonts.push({ label: fontName, url: fontUrl });
                console.log('[SiteCache] SiteCache after adding font', SiteCache.customUserFonts);
            }
            else {
                console.log('Site font exists', siteFont);
            }
        }
        catch (err) {
            console.warn('Could not add font into SiteCache', err);
        }
        userFont
            .load()
            .then(() => {
            document.fonts.add(userFont);
            resolve(userFont);
        })
            .catch(err => {
            console.warn('Could not load user font ', fontName, err);
            reject(err);
        });
    });
};
export const loadCustomFont = async (fontName, fontLocation) => {
    return new Promise((resolve, reject) => {
        let site = window.location.protocol + '//' + window.location.hostname;
        if (window.location.port)
            site += ':' + window.location.port;
        let font = new FontFace(fontName, `url(${site}/wp-content/uploads/commun_templates/fonts/${fontLocation})`);
        font
            .load()
            .then(() => {
            //console.log('Loaded custom font', font);
            document.fonts.add(font);
            resolve(font);
        })
            .catch(err => {
            console.warn('Could not load custom font ', fontName, err);
            reject(err);
        });
    });
};
export const templateFontStore = writable([]);
export function getPrimaryFont() { }
function removeSpecialCharacters(str) {
    // Remove whitespace at the beginning and end
    return str.trim().replace(/"/g, '');
}
function detectFontsInElement(element) {
    console.log('Detecting fonts in element', element);
    let allElements = element.querySelectorAll('.dynamic');
    let fontFamilies = [];
    allElements.forEach(function (el) {
        let style = window.getComputedStyle(el);
        let fontFamily = style.getPropertyValue('font-family');
        const targetFamily = fontFamily.split(',').map(removeSpecialCharacters)[0];
        if (targetFamily && !fontFamilies.includes(targetFamily)) {
            fontFamilies.push(targetFamily);
        }
        let index = fontFamilies.indexOf(targetFamily);
        if (index == 0)
            el.classList.add('primary-font');
        else
            el.classList.add('secondary-font');
    });
    return fontFamilies;
    // return fontFamilies.filter(font => font != 'Roboto');
}
export class FontLoader {
    node;
    fonts = [];
    constructor(node) {
        this.node = node;
        this.readTemplateFonts();
    }
    readTemplateFonts() {
        // Read all fonts from the node property and assign them to fonts array
        //console.log('Read template fonts');
        // Nodelist to array
        const fonts = detectFontsInElement(this.node);
        this.fonts = fonts.flat();
        if (this.fonts.length == 1)
            this.fonts.push('');
        templateFontStore.set(this.fonts);
    }
}
